const PRECISION = 1000;
const PERCENT = 100;

export default {
	PRECISION,
	PERCENT
};
